<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" appendTo="body"
          [style]="{'width': '960px', 'height': '800px'}">

    <p-header>
        <span>Ip/Mac Finder Results</span>
    </p-header>

    <div style="overflow: hidden;">
        <info-viewer [infoSetView]="sightings" scrollHeight="600px" [show]="true"></info-viewer>
    </div>

    <p-footer>
        <button type="button" pButton icon="fa fa-check" [disabled]="false" (click)="onOkClicked()" label="OK"></button>
    </p-footer>

</p-dialog>
